module.exports = __webpack_public_path__ + "img/safe.ee18df1d.svg";